module.exports = __webpack_public_path__ + "img/icon-search.bfabaeaa.svg";